import React, { useEffect, useRef } from 'react';
import { ensureFontLoaded } from '@/lib/fonts';

interface FontOptionButtonProps {
  font: string;
  className?: string;
  onSelect: () => void;
}

/** Bouton de choix de police : la police n'est téléchargée que lorsque la ligne devient visible. */
const FontOptionButton: React.FC<FontOptionButtonProps> = ({ font, className, onSelect }) => {
  const btnRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const el = btnRef.current;
    if (!el) return;
    if (typeof IntersectionObserver === 'undefined') {
      ensureFontLoaded(font);
      return;
    }
    const obs = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        ensureFontLoaded(font);
        obs.disconnect();
      }
    }, { threshold: 0.01 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [font]);

  return (
    <button ref={btnRef} onClick={onSelect} className={className} style={{ fontFamily: font }}>
      {font}
    </button>
  );
};

export default FontOptionButton;
